<template>
  <vs-popup :title="title" :active.sync="addNewDataLocal" @vs-close="closeForm">
    <form @submit.prevent>
      <vs-row vs-w="12">
        <vs-col vs-justify="center pl-0" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card class="shadow">
            <h4>Old Data</h4>
            <vs-divider style="margin: 4px 0;"/>
            <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
              <label class="vs-input--label">Fleet Group</label>
              <v-select @input="x=> fleet_group_id=x.value" disabled :clearable="false"
                        :value="getSelectValue(fleet_group_id,fleet_group_array)" :reduce="text => text.value"
                        label="text" :options="fleet_group_array"/>
            </div>
            <!--<vs-select  autocomplete  v-model="fleet_group_id" label="Fleet Group" class="w-full mb-5">-->
            <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in fleet_group_array" />-->
            <!--</vs-select>-->
            <!--<vs-select autocomplete  v-model="license_plate" label="Vehicle Plate Number" class="w-full mb-5" :disabled="vehicle_array.length==0">-->
            <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in vehicle_array" />-->
            <!--</vs-select>-->
            <vs-input disabled label="License Plate" name="machine_number" v-model="license_plate" class="mb-5 w-full"/>
            <vs-input disabled label="Machine Number" name="machine_number" v-model="machine_number"
                      class="mb-5 w-full"/>
            <vs-input disabled label="VIN" name="vin" v-model="vin" class="mb-5 w-full"/>
            <vs-input disabled label="Old IMEI Number" name="imei_obd_number" v-model="imei_old" class="mb-5 w-full"/>
          </vx-card>


        </vs-col>
        <vs-col vs-justify="center " class="pr-0 pl-0" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <vx-card class="shadow" style="padding: 1.5rem 7px;">
            <template slot="no-body">
              <h4>New Data</h4>
              <vs-divider style="margin: 4px 0;"/>
              <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                <label class="vs-input--label">Installation Date</label>
                <feather-icon icon="CalendarIcon" svgClasses="h-6 w-6"
                              style="position: absolute !important; right: 6px; top: 28px;"/>
                <Datepicker label="Installation Date" placeholder="Installation Date"
                            v-model="installation_date"></Datepicker>
              </div>

              <vs-input label="New IMEI Number" name="imei_obd_number" v-model="imei_new" class="mb-5 w-full"/>
              <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                <label class="vs-input--label">Device Group</label>
                <v-select @input="x=> device_group_id=x.value" :clearable="false"
                          :value="getSelectValue(device_group_id,dataDeviceGroup)" :reduce="text => text.value"
                          label="text" :options="dataDeviceGroup"/>
              </div>
              <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                <label class="vs-input--label">Device Model</label>
                <v-select @input="x=> device_model_id=x.value" :clearable="false"
                          :value="getSelectValue(device_model_id,dataDeviceModel)" :reduce="text => text.value"
                          label="text" :options="dataDeviceModel"/>
              </div>
              <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                <label class="vs-input--label">Device Type</label>
                <v-select @input="x=> device_type_id=x.value" :clearable="false"
                          :value="getSelectValue(device_type_id,dataDeviceType)" :reduce="text => text.value"
                          label="text" :options="dataDeviceType"/>
              </div>
              <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary"
                   style="white-space: normal;">
                <label class="vs-input--label">End Points</label>
                <v-select class="drop-height-auto" multiple placeholder="- Select End Points -" :clearable="true"
                          v-model="end_points" label="text" :options="dataEndPoints"/>
              </div>
            </template>
            <!--padding: 1.5rem 6px;-->

          </vx-card>

        </vs-col>

      </vs-row>

    </form>
    <vs-divider/>
    <div class="vx-row">
      <div class="vx-col w-full p-2" style="    padding-left: 21px !important;">
        <vs-button class="mr-3 mb-2 btn-load-1 vs-con-loading__container ml-2" @click="submitForm"
                   :disabled="device_group_id=='' || device_model_id=='' || device_type_id=='' || imei_new==''">Submit
        </vs-button>
        <!--<vs-button class="mr-3 mb-2 btn-load-2 vs-con-loading__container" @click="updateForm" v-if="editMode">Update</vs-button>-->
        <!--<vs-button color="danger" class="mr-3 mb-2 btn-load-3 vs-con-loading__container" @click="deleteData" v-if="editMode">Delete</vs-button>-->
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm">Cancel</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>

import * as REPO from '../../../repository/index'
import Datepicker from 'vuejs-datepicker';
import * as moment from 'moment';

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true
    },
    title: String,
    allData: Array,
    dataModel: Array,
    dataBrand: Array,
    dataDeviceGroup: Array,
    // dataVehicle: Array,
    dataEndPoints: Array,
    dataDeviceModel: Array,
    dataDeviceType: Array,
    dataFleetGroup: Array,
    editMode: Boolean,
    dataEdit: Object
  },
  components: {
    Datepicker
  },
  data() {
    return {
      model_array: [],
      brand_array: [],
      end_points: [],
      fleet_group_array: [],
      vehicle_array: [],
      vehicle_brand: '',
      vin: '',
      imei_old: '',
      active_array: [{
        text: 'Active',
        value: '1'
      }, {
        text: 'Inactive',
        value: '0'
      }],
      imei_new: '',
      description: '',
      machine_number: '',
      device_type_id: '',
      device_group_id: '',
      device_model_id: '',
      vehicle_type: '',
      vehicle_color: '',
      status: '1',
      fleet_group_id: '',
      vehicle_year: '',
      stnk_date: '',
      start_date_maintenance: '',
      end_date_maintenance: '',
      installation_date: '',
      odometer: '',
      imei_obd_number: '',
      simcard_number: '',
      license_plate: '',
      vehicle_id: '',
      vehicle_model: ''
    }
  },
  watch: {
    imei_new(val) {
      if (this.imei_new)
        this.imei_new = val.toUpperCase();
    },
    fleet_group_id(val) {
      this.compute(val);
    },
    // license_plate(val){
    //     let tmp =   this.dataVehicle.filter(x=>{
    //         return x.license_plate == val;
    //     });
    //     if(tmp.length>0){
    //         this.vin = tmp[0].vin;
    //         this.machine_number = tmp[0].machine_number;
    //         this.vehicle_id = tmp[0].id;
    //         this.imei_old = tmp[0].imei_obd_number;
    //     }
    // },
    editMode(val) {
      if (val) {
        // this.s_alert = this.dataEdit.alert_id;
        // this.calculateFleetEdit(this.s_alert);
        // this.fleetGroup = this.dataEdit.fleet_group_id;

        // ("EDIT mode")
      } else {
        // ("new")
      }
    },
    s_alert(val) {
      this.calculateFleet(val);
    }
  },
  mounted() {
    // ("Mounted");
    // this.getDeviceData();
  },
  computed: {
    addNewDataLocal: {
      get() {
        this.clearFields();
        if (this.dataFleetGroup.length > 0 && this.addNewData) {
          this.fleet_group_array = [];
          let tmp = [];
          this.dataFleetGroup.forEach(x => {
            tmp.push({
              value: x.id,
              text: x.fleet_group_name
            })
          });
          this.fleet_group_array = tmp;
        }
        if (this.addNewData && this.editMode) {
          // ("Edit Mode");
          // (this.dataEdit);
          this.fleet_group_id = this.dataEdit.fleet_group_id;
          this.compute(this.dataEdit.fleet_group_id);
          this.license_plate = this.dataEdit.license_plate;
          this.vin = this.dataEdit.vin;
          this.vehicle_id = this.dataEdit.vehicle_id;
          this.machine_number = this.dataEdit.machine_number;
          this.description = this.dataEdit.description;

          this.status = this.dataEdit.status;
          this.start_date_maintenance = moment(this.start_date_maintenance.stnk_date).format("YYYY-MM-DD HH:mm");
          this.end_date_maintenance = moment(this.end_date_maintenance.installation_date).format("YYYY-MM-DD  HH:mm");
          this.imei_new = this.dataEdit.imei_new;
          this.imei_old = this.dataEdit.imei_old;
        }
        return JSON.parse(this.addNewData);
      },
      set(val) {

        if (!val) {
          // (val);
          this.$emit('closeModal');
        }
      }
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != '';
    },
  },

  methods: {
    compute(val) {
      this.vehicle_array = [];
      // let tmp = this.dataVehicle.filter(x=>{
      //     return x.fleet_group_id == val;
      // })
      // tmp.forEach(x=>{
      //     this.vehicle_array.push({
      //         text:x.license_plate,
      //         value:x.license_plate
      //     })
      // })
    },
    closeForm() {
      this.clearFields();
      this.$emit('closeModal', false);
    },
    clearFields() {
      this.license_plate = "";
      this.vin = '';
      this.vehicle_id = '';
      this.machine_number = '';
      this.fleet_group_id = '';
      this.status = '';
      this.description = '';
      this.start_date_maintenance = '';
      this.end_date_maintenance = '';
      this.installation_date = '';
      this.imei_new = '';
      this.imei_old = '';
      this.end_points = [];
      this.device_group_id = '';
      this.device_model_id = '';
      this.device_type_id = '';
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45
      });
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitForm() {
      this.loadingBtnStart('btn-load-1');
      // let dataForm={
      //     license_plate : this.license_plate,
      //     vin : this.vin,
      //     vehicle_id : this.vehicle_id,
      //     description : this.description,
      //     machine_number : this.machine_number,
      //     fleet_group_id : this.fleet_group_id,
      //     status : this.status,
      //     start_date_maintenance:moment(this.start_date_maintenance).format("YYYY-MM-DD HH:mm"),
      //     end_date_maintenance:moment(this.end_date_maintenance).format("YYYY-MM-DD HH:mm"),
      //     imei_old : this.imei_old,
      //     imei_new : this.imei_new,
      //     created_by : this.$dataLocal.UserData().name
      // };

      let endPoints;
      if (this.end_points.length > 0) {
        endPoints = this.end_points[0].value;
      }

      if (this.end_points.length > 1) {
        this.end_points.forEach((x, i) => {
          if (i > 0)
            endPoints += ("," + x.value);
        })
      }
      let dataForm = {
        license_plate: this.license_plate,
        vin: this.vin,
        installation_date: moment(this.installation_date).format("YYYY-MM-DD"),
        end_points: endPoints,
        device_group_code: this.device_group_id,
        device_model_code: this.device_model_id,
        device_type_code: this.device_type_id,
        imei_new: this.imei_new,
        updated_by: this.$dataLocal.UserData().name
      };
      REPO.updateVehicleMaintenance(dataForm).then(res => {
        this.loadingBtnStop('btn-load-1');
        if (res.data.status == "true") {
          this.$emit('submitModal', false);
          this.clearFields();
          this.$toast.success('Data Successfullly Submitted');
        } else {
          this.$toast.error(res.data.error_msg);
        }
      }).catch(err => {
        this.loadingBtnStop('btn-load-1');
        // (err);
        this.$toast.error(err.message);
      });
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3');
      REPO.deleteVehicleMaintenance(this.dataEdit.id).then(res => {
        this.clearFields();
        this.loadingBtnStop('btn-load-3');
        this.$emit('submitModal', false);
        this.$toast.error("Data Successfully Deleted");
      }).catch(err => {
        // (err);
        this.loadingBtnStop('btn-load-3');
        this.$toast.error(err.message);
      });
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2');
      let dataForm = {
        license_plate: this.license_plate,
        vin: this.vin,
        vehicle_id: this.vehicle_id,
        machine_number: this.machine_number,
        description: this.description,
        fleet_group_id: this.fleet_group_id,
        status: this.status,
        start_date_maintenance: moment(this.start_date_maintenance).format("YYYY-MM-DD HH:mm"),
        end_date_maintenance: moment(this.end_date_maintenance).format("YYYY-MM-DD HH:mm"),
        imei_old: this.imei_old,
        imei_new: this.imei_new,
        created_by: this.$dataLocal.UserData().name
      };
      REPO.updateVehicleMaintenance(dataForm, this.dataEdit.id).then(res => {
        this.loadingBtnStop('btn-load-2');
        if (res.data.status == "true") {
          this.$emit('submitModal', false);
          this.clearFields();
          this.$toast.success('Data Successfullly Submitted');
        } else {
          this.$toast.error(res.data.error_msg);
        }
      }).catch(err => {
        // (err);
        this.loadingBtnStop('btn-load-2');
        this.$toast.error(err.message);
      });
    }
  },
}
</script>
<style>
.luas_aja > .vs-popup > .vs-popup--content {
  background: #f8f8f8;
  padding: 0 !important;
  margin: 0 !important;
}

</style>
<style scoped>
.vdp-datepicker > div > input {
  background: transparent;
  width: 100% !important;
}
</style>
